import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { trackError } from "app/pages/sales-intelligence/utils/errors/tracking";
import { errorCategoryMap, SiError } from "app/pages/sales-intelligence/utils/errors/types";

import { serializeExtensionSettings } from "../../services/serialization";
import type { ExtensionSettings } from "../../types";
import { extensionSettingsQueryKeys } from "../key-factory/factory";

export const useUpdateExtensionSettingsMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn(settings: ExtensionSettings) {
            return salesApiService.accountSettings.saveExtensionDefaults(serializeExtensionSettings(settings));
        },
        onSuccess() {
            void queryClient.invalidateQueries({ queryKey: extensionSettingsQueryKeys.settings() });
        },
        onError(error) {
            trackError(
                new SiError(
                    "Failed to save extension settings",
                    {
                        category: errorCategoryMap.api,
                        operation: "saveExtensionSettings",
                    },
                    { cause: error },
                ),
            );
        },
    });
};
